import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/config';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Toast from '../components/Toast';
import Breadcrumbs from '../components/Breadcrumbs';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin');
    } catch (error) {
      console.error('Login error:', error);
      let errorMessage = 'Error logging in. Please try again.';

      if (
        error.code === 'auth/invalid-credential' ||
        error.code === 'auth/user-not-found' ||
        error.code === 'auth/wrong-password' ||
        error.code === 'auth/invalid-email' ||
        error.code === 'auth/invalid-login-credentials'
      ) {
        errorMessage = 'Invalid email or password. Please try again.';
      } else if (error.code === 'auth/user-disabled') {
        errorMessage = 'This account has been disabled. Please contact support.';
      } else if (error.code === 'auth/too-many-requests') {
        errorMessage = 'Too many failed login attempts. Please try again later.';
      }

      setToast({
        message: errorMessage,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    'w-full px-4 py-3 bg-charcoal-card border border-white/10 rounded-lg text-white placeholder-slate-500 focus:ring-2 focus:ring-banana-yellow focus:border-transparent';

  return (
    <div className="min-h-screen flex flex-col bg-charcoal-dark text-slate-200">
      <Header />
      <Breadcrumbs />

      <main
        id="main-content"
        className="flex-grow flex items-center justify-center max-w-md mx-auto w-full px-4 md:px-8 py-12"
      >
        <div className="chrome-panel border border-white/5 rounded-lg p-6 md:p-8 w-full">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center uppercase tracking-tight">
            Admin Login
          </h2>
          <p className="text-center text-slate-500 text-sm mb-6">
            Not By Chance outreach staff only. Unauthorized access is prohibited.
          </p>
          <p className="text-center text-slate-600 text-xs mb-6 leading-relaxed">
            This portal contains sensitive location and contact information. Use only on trusted devices.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2 uppercase tracking-wider">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                className={inputClass}
                placeholder="admin@example.com"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-slate-300 mb-2 uppercase tracking-wider">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className={inputClass}
                placeholder="Enter your password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full cyber-btn-yellow disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="text-slate-400 hover:text-banana-yellow text-sm transition-colors"
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </main>

      <Footer />

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default AdminLogin;
